/* FACTS · hochzaehlende Kennzahlen
   ------------------------------------------------------------------
   <facts-count data-value="50+" data-duration="1400">50+</facts-count>

   Der Endwert steht bereits im HTML - ohne JS, fuer Suchmaschinen und
   Vorlesesoftware ist die Zahl also sofort da. JS ersetzt den Text nur
   waehrend der Animation.

   Regeln aus dem Section-Standard §8:
   - Start erst beim Sichtbarwerden (IntersectionObserver), einmalig
   - Animation ueber requestAnimationFrame, kein Timer
   - prefers-reduced-motion: kein Hochzaehlen, Endwert steht sofort
   - Praefix und Suffix bleiben erhalten ("50+", "100%", "ab 99 EUR") */
(function () {
  if (customElements.get('facts-count')) return;
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* "50+" -> {pre:"", num:50, post:"+", dec:0} */
  function parse(raw) {
    var m = String(raw).match(/^(\D*?)([\d]+(?:[.,]\d+)?)(.*)$/);
    if (!m) return null;
    var numTxt = m[2];
    var sep = numTxt.indexOf(',') > -1 ? ',' : '.';
    var dec = numTxt.split(sep)[1] ? numTxt.split(sep)[1].length : 0;
    return { pre: m[1], num: parseFloat(numTxt.replace(',', '.')), post: m[3], dec: dec, sep: sep };
  }

  function fmt(p, v) {
    var s = v.toFixed(p.dec);
    if (p.sep === ',') s = s.replace('.', ',');
    return p.pre + s + p.post;
  }

  class FactsCount extends HTMLElement {
    connectedCallback() {
      this._parts = parse(this.getAttribute('data-value') || this.textContent);
      if (!this._parts || REDUCE) return;
      this._dur = parseInt(this.getAttribute('data-duration'), 10) || 1400;
      this._done = false;
      this._io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !this._done) { this._done = true; this._run(); this._io.disconnect(); }
        }.bind(this));
      }.bind(this), { threshold: 0.35 });
      /* Startwert erst setzen, wenn wirklich animiert wird - sonst blitzt
         bei abgebrochenem Laden eine 0 auf. */
      this.textContent = fmt(this._parts, 0);
      this._io.observe(this);
    }

    _run() {
      var p = this._parts, dur = this._dur, t0 = null, self = this;
      function frame(ts) {
        if (t0 === null) t0 = ts;
        var k = Math.min((ts - t0) / dur, 1);
        /* easeOutCubic: schnell los, sanft ankommen */
        var e = 1 - Math.pow(1 - k, 3);
        self.textContent = fmt(p, p.num * e);
        if (k < 1) requestAnimationFrame(frame);
        else self.textContent = fmt(p, p.num);
      }
      requestAnimationFrame(frame);
    }

    disconnectedCallback() { if (this._io) this._io.disconnect(); }
  }
  customElements.define('facts-count', FactsCount);
})();
